<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <CrosshairIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('customer.list') }}</h2>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <ListTable />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ListTable from '@/components/customers/ListTable'

export default defineComponent({
  components: {
    ListTable
  },
  setup() {
    return {}
  }
})
</script>
